@use "../../../globals/bcp";

:host {
  @include bcp.acc-hide();
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
